import { Button, IconButton, PurpleLight } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import { useCallback } from "react";
import { ClaraEntryPoint } from "../../../../../../features/ai-chatbot/constants/clara-entry-point.enum";
import useIsMobile from "../../../../../../hooks/device/useIsMobile";
import { AiChatbotIcon } from "../../../../Chatbot/components/ai-chatbot-icon/ai-chatbot-icon";
import { useChatbotPanel } from "../../../../Chatbot/hooks/use-chatbot-panel/use-chatbot-panel";
import { useChatbotPlaceholder } from "../../../../Chatbot/hooks/use-chatbot-placeholder/use-chatbot-placeholder";
import { trackAiAssistantIconClicked } from "./header-v2-ai-assistant-icon-button.event";

const AiAssistantIconButton = styled(IconButton)({
  backgroundColor: PurpleLight.main,
  color: PurpleLight.contrastText,
  "&:hover": {
    backgroundColor: PurpleLight.main,
  },
  "&:active": {
    backgroundColor: PurpleLight.main,
  },
  "&:focus": {
    backgroundColor: PurpleLight.main,
  },
});

function HeaderV2AiAssistantIconButton(): JSX.Element {
  const isMobile = useIsMobile();
  const chatbotPlaceholder = useChatbotPlaceholder({});
  const { isChatbotOpen, closeChatbotPanel, openChatbotPanel } = useChatbotPanel();

  const handleClick = useCallback(
    function handleAIAssistantButtonClick() {
      if (isChatbotOpen) {
        closeChatbotPanel();
      } else {
        openChatbotPanel(ClaraEntryPoint.NAVIGATION_BUTTON);
        trackAiAssistantIconClicked();
      }
    },

    [closeChatbotPanel, isChatbotOpen, openChatbotPanel]
  );

  if (isMobile) {
    return (
      <AiAssistantIconButton onClick={handleClick}>
        <AiChatbotIcon animated={true} />
      </AiAssistantIconButton>
    );
  }

  return (
    <Button
      color="purpleLight"
      variant="contained"
      startIcon={<AiChatbotIcon animated={true} />}
      sx={{ whiteSpace: "nowrap" }}
      onClick={handleClick}
    >
      {chatbotPlaceholder}
    </Button>
  );
}

export default HeaderV2AiAssistantIconButton;
